export const FILENAME_PARAMS = 'c19s.params.json'
export const FILENAME_RESULTS_SUMMARY = 'c19s.results.summary.tsv'
export const FILENAME_RESULTS_DETAILED = 'c19s.results.detailed.tsv'
export const FILENAME_ZIP = 'c19s.zip'
